import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { BASE_URL } from '../../Utils/BaseUrl';
import axios from 'axios';

const YourGroups = () => {
  const [groupdata, setgroupData] = useState([]);
  const [openMenu, setOpenMenu] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [value, setValues] = useState({
    title: '',
    keyword: '',
    image: '',
  });
  const [image, setImage] = useState(null);

  const toggleForm = () => setShowForm(!showForm);

  // Fetch group data
  async function getgroupdata() {
    const data = { user_id: localStorage.getItem('user_id') };
    try {
      const res = await axios.post(`${BASE_URL}/group_name`, data);
      setgroupData(res.data);
    } catch (err) {
      console.log(err);
      alert("Failed to load groups");
    }
  }

  useEffect(() => {
    getgroupdata();
  }, []);

  const toggleMenu = (id) => {
    setOpenMenu(openMenu === id ? null : id);
  };


  const deleteGroup = async (id) => {

    if (!window.confirm("Remove this group?")) return;

    const data = {
      group_id: id,
      user_id: localStorage.getItem("user_id"),
    };

    try {

      await axios.post(`${BASE_URL}/remove_group`, data);

      alert("Group removed successfully");

      setOpenMenu(null);

      getgroupdata();

    } catch (err) {

      console.log(err);

      alert("Failed to remove group");

    }

  };

  // Convert image to base64
  async function ImageBase64(file) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    return new Promise((resolve, reject) => {
      reader.onload = () => resolve(reader.result);
      reader.onerror = (err) => reject(err);
    });
  }

  const handleUpload = async (e) => {
    const data = await ImageBase64(e.target.files[0]);
    setImage(e.target.files[0]);
    setValues(prev => ({ ...prev, image: data }));
  };

  const handleInput = (e) => {
    setValues(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!value.title || !value.keyword || !image) {
      alert("All fields are required");
      return;
    }

    const formData = new FormData();
    formData.append('image', image);
    formData.append('user_id', localStorage.getItem('user_id'));
    formData.append('title', value.title);
    formData.append('keyword', value.keyword);

    try {
      await fetch(`${BASE_URL}/create_group`, { method: 'POST', body: formData });
      alert("Group created successfully");
      getgroupdata();
      setValues({ title: '', keyword: '', image: '' });
      setImage(null);
      setShowForm(false);
    } catch (err) {
      console.log(err);
      alert("Error creating group");
    }
  };

  return (
    <div>
      <div className="suggestions full-width">
        <div className="sd-title d-flex justify-content-between align-items-center">
          <h3>Your Groups</h3>
          <button
            type="button"
            className="px-3 py-1 bg-primary text-white font-medium rounded-lg border-0 hover:bg-blue-700 hover:scale-105 transition-all flex items-center gap-2"
            title="Add a new group"
            onClick={toggleForm}
          >
            Add +
          </button>
        </div>

        {/* Modal / Form */}
        {showForm && (
          <div className="modal-overlay">
            <div className="modal-content">
              <b onClick={toggleForm} title="Close" className="close-btn">&times;</b>
              <form onSubmit={handleSubmit} className="group-form">
                <div className="form-group">
                  <label>Group Title</label>
                  <input
                    type="text"
                    name="title"
                    value={value.title}
                    onChange={handleInput}
                    placeholder="Enter group title"
                    className="form-control"
                  />
                </div>

                <div className="form-group">
                  <label>Keywords</label>
                  <input
                    type="text"
                    name="keyword"
                    value={value.keyword}
                    onChange={handleInput}
                    placeholder="Add keywords"
                    className="form-control"
                  />
                </div>

                <div className="form-group">
                  <label>Group Image</label>
                  <input type="file" accept="image/*" onChange={handleUpload} />
                  {value.image && (
                    <img
                      src={value.image}
                      alt="preview"
                      className="image-preview"
                    />
                  )}
                </div>

                <div className="form-group submit-container">
                  <button type="submit" className="btn btn-primary">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Group List */}
        <div className="suggestions-list mt-3">
           {groupdata.length === 0 && (
    <div className="text-center py-4 text-muted">
      <i className="bi bi-people" style={{ fontSize: "40px" }}></i>
      <p className="mt-2 mb-0">No Groups Created Yet</p>
    </div>
  )}
          {groupdata.map((item) => (

            <div key={item.id} className="suggestion-usd d-flex align-items-center justify-content-between mb-2">

              <div className="d-flex align-items-center">

                <img
                  src={`https://thetalentclub.co.in/upload/group_images/${item.image}`}
                  style={{ width: 50, height: 50, borderRadius: 8 }}
                  alt=""
                />

                <Link to={`/clubdetailpage/${item.id}`} className="ms-2">

                  <div className="sgt-text">
                    <h4>{item.title}</h4>
                    <span>{item.keyword}</span>
                  </div>

                </Link>

              </div>

              {/* 3 DOT MENU */}
              <div style={{ position: "relative" }}>

                <i
                  className="bi bi-three-dots-vertical"
                  style={{ cursor: "pointer", fontSize: 20 }}
                  onClick={() => toggleMenu(item.id)}
                ></i>

                {openMenu === item.id && (

                  <div className="menu-box">

                    <button
                      className="delete-btn"
                      onClick={() => deleteGroup(item.id)}
                    >
                      Remove
                    </button>

                  </div>

                )}

              </div>

            </div>

          ))}
        </div>
      </div>

      {/* Styles for modal */}
      <style jsx>{`
        .modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: #fff;
  padding: 2rem;
  border-radius: 8px;
  width: 400px;
  position: relative;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 15px;
  cursor: pointer;
  font-size: 1.5rem;
}

.group-form .form-group {
  margin-bottom: 1rem;
}

.image-preview {
  margin-top: 0.5rem;
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #ddd;
}

.submit-container {
  display: flex;
  justify-content: flex-end;
}
  .menu-box{
position:absolute;
right:0;
top:25px;
background:white;
border:1px solid #ddd;
border-radius:6px;
box-shadow:0 4px 10px rgba(0,0,0,0.15);
padding:5px;
z-index:100;
}

.delete-btn{
background:#ff4d4f;
color:white;
border:none;
padding:6px 12px;
border-radius:4px;
cursor:pointer;
}

.delete-btn:hover{
background:#d9363e;
}
      `}</style>
    </div>
  );
};

export default YourGroups;